/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sort_Last_CookedInputs */

const en_sort_last_cooked = /** @type {(inputs: Sort_Last_CookedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last cooked`)
};

const de_sort_last_cooked = /** @type {(inputs: Sort_Last_CookedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuletzt gekocht`)
};

/**
* | output |
* | --- |
* | "Last cooked" |
*
* @param {Sort_Last_CookedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sort_last_cooked = /** @type {((inputs?: Sort_Last_CookedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sort_Last_CookedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sort_last_cooked(inputs)
	return en_sort_last_cooked(inputs)
});